import React, {useState, useEffect} from 'react'
// Styles
import './myrw-style.css'
// Actions
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
//  Components
import MyReward_Card from '../../components/MyReward_Card'
import RedeemDetails from '../../components/RedeemDetails'
import Overlay from '../../components/Overlay'
// Toast
import {toast as notify, Toaster} from 'react-hot-toast'
import { DecryptedOBJ, EncryptedText } from '../../utils/Encryption'
// Line
import useLineLogin from '../../_actions/authLine/lineLogin'
import lineConfig from '../../_actions/authLine/lineConfig'
import { authenAll } from '../../_actions/sso.authen'



function MyReward() {

    const [loading, setLoading] = useState(true);
    const [myRewards, setMyRewards] = useState([]);
    const [memberData, setMemberData] = useState(null);
    const [redeemDetail, setRedeemDetail] = useState(null);
    const [openDetail, setOpenDetail] = useState(false);

    useEffect(() => {
        dataInit();
    }, [])

    const dataInit = async() => {
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)

        await useLineLogin(lineConfig.my_reward);
        await authenAll(lineConfig.my_reward);
        let getMember = await checkUserInit();
        await myRewardInit(getMember);
        handlerLoader('inactive');
    }

    const handlerLoader = status => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    // console.log('Get Member: ', res);
                    if(res.isSuccess === true)
                    {
                        setMemberData(res.member);
                        resolve(res.member);
                    }else
                    {
                        if(res.errMessage === 'not found !.')
                        {
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE);
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA);
                            location.reload();
                        }
                    }
                })
            }else
            {
                await useLineLogin(lineConfig.my_reward);
            }
        })
    }

    const goToRegisCard = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/welcome-card-register`;
    }

    const onSelected = async(id) => {
        await getRedeemDetail(id);
    }

    const handlerDetail = (status) => {
        if(status === 'inactive')
        {
            setOpenDetail(false);
            document.body.style.overflow = "scroll";
        }else
        {
            setOpenDetail(true);
            document.body.style.overflow = "hidden";
        }
    }; 

    const getRedeemDetail = (id) => {
        // console.log('Selected ID: ', id);
        return new Promise(async resolve => {
            NhealthAction.GetRedeemDetail(id, memberData.membercode)
            .then(res => {
                if(res.isSuccess === true)
                {
                    setRedeemDetail(res.reward);
                    handlerDetail('active');
                }
                // console.log('Get Redeem Detail: ', res);
            }) 
        })
    }

    const myRewardInit = (data) => {
        return new Promise(async resolve => {
            NhealthAction.GetMyRewards(data.membercode)
            .then(res => {
                setMyRewards(res.reward);
            })
            resolve();
        })
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )    }else
    {
        return (
            <div className="myrw-container">
                {/* Header Text */}
                <h1 className="header-text">รีวอร์ดของฉัน</h1>
    
                {/* My reward card */}
                {myRewards.length === 0 &&
                    <p className="notfound">ไม่พบข้อมูล</p> 
                }

                {myRewards.length > 0 && myRewards.map((item, i) => 
                    <div className="myrw-card" key={i}>
                        <MyReward_Card 
                            data={item}
                            key={i}
                            onSelected={onSelected}
                        />
                    </div>
                )}

                <RedeemDetails 
                    openDetail={openDetail} 
                    setOpenDetail={setOpenDetail}
                    data={redeemDetail}
                    notify={notify}
                />
                <Overlay setOpenDetail={setOpenDetail} openDetail={openDetail} />
                <Toaster/>
            </div>
        )
    }
}

export default MyReward